const flow = ['Бизнес-задача', 'Компетенции', 'Диагностика', 'Обучение', 'Практика', 'Развитие', 'Оценка'];

const steps = [
  { num: '1', title: 'Определение бизнес-задач', desc: 'Какие результаты необходимо улучшить? Отправная точка — не список тем, а конкретные задачи компании.' },
  { num: '2', title: 'Определение необходимых компетенций', desc: 'Какие навыки сотрудников влияют на эти результаты? Выбираем те компетенции, которые напрямую связаны с задачей.' },
  { num: '3', title: 'Диагностика', desc: 'Что сотрудники уже умеют и где находятся дефициты? Понимаем текущий уровень, чтобы не учить тому, что уже освоено.' },
  { num: '4', title: 'Обучение', desc: 'Какие знания и навыки необходимо сформировать? Проводим практическую программу, адаптированную под компанию.' },
  { num: '5', title: 'Практика', desc: 'Как сотрудники будут применять новое в реальной работе? Отрабатываем навыки на рабочих ситуациях, а не на абстрактных примерах.' },
  { num: '6', title: 'Наставничество и обратная связь', desc: 'Кто поможет закрепить изменения? Подключаем руководителей и наставников, чтобы навык удержался в ежедневной практике.' },
  { num: '7', title: 'Оценка', desc: 'Как понять, что компетенции действительно изменились? Проводим повторную диагностику и смотрим на изменение поведения.' },
  { num: '8', title: 'Дальнейшее развитие', desc: 'Какие следующие компетенции необходимо развивать? Переходим на следующий уровень — развитие становится непрерывным.' },
];

export default function SystemSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как связать обучение, практику и развитие
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Система развития персонала — это не разовое мероприятие, а последовательность шагов, каждый из которых отвечает на конкретный вопрос.
        </p>

        <div className="bg-gray-50 rounded-2xl border border-gray-200 p-6 md:p-8 mb-12">
          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3">
            {flow.map((item, i) => (
              <div key={item} className="flex items-center gap-2 md:gap-3">
                <div className="bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
                  {item}
                </div>
                {i < flow.length - 1 && (
                  <i className="ri-arrow-right-line text-teal-400 text-lg flex-shrink-0"></i>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="absolute left-6 md:left-8 top-8 bottom-8 w-0.5 bg-teal-200 hidden md:block"></div>

          <div className="space-y-6 md:space-y-8">
            {steps.map((step, i) => (
              <div key={i} className="relative flex gap-5 md:gap-8 items-start">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-teal-600 text-white rounded-xl flex items-center justify-center flex-shrink-0 relative z-10">
                  <span className="text-xl md:text-2xl font-extrabold">{step.num}</span>
                </div>
                <div className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 flex-grow">
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}